/** Snippet para mostrar variantes de cadena con autoplay y scroll snap - Digital Thinking **/

document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('.sibling-slider-wrapper');
  if (!wrapper) return;

  const productId = wrapper.dataset.productId;
  const currentKey = 'selected_variant_' + productId;
  const scrollKey = 'slider_scroll_' + productId;

  // Limpia otras selecciones
  const keys = Object.keys(localStorage);
  keys.forEach(k => {
    if ((k.startsWith('selected_variant_') && k !== currentKey) || (k.startsWith('slider_scroll_') && k !== scrollKey)) {
      localStorage.removeItem(k);
    }
  });

  const container = wrapper.querySelector('.sibling-variants');
  const storedVariant = localStorage.getItem(currentKey);
  if (storedVariant) {
    const swatch = wrapper.querySelector(`[data-variant-id="${storedVariant}"]`);
    if (swatch) {
      swatch.classList.add('active');
      swatch.scrollIntoView({ behavior: 'smooth', inline: 'start' });
    }
  }

  const savedScroll = parseInt(localStorage.getItem(scrollKey), 10);
  if (!isNaN(savedScroll)) container.scrollLeft = savedScroll;

  container.addEventListener('scroll', () => {
    localStorage.setItem(scrollKey, container.scrollLeft);
  });

  wrapper.querySelectorAll('.sibling-variant-button').forEach(el => {
    el.addEventListener('click', () => {
      wrapper.querySelectorAll('.sibling-variant-button').forEach(b => b.classList.remove('active'));
      el.classList.add('active');
      localStorage.setItem(currentKey, el.dataset.variantId);
    });

    el.addEventListener('touchend', () => {
      wrapper.querySelectorAll('.sibling-variant-button').forEach(b => b.classList.remove('active'));
      el.classList.add('active');
      localStorage.setItem(currentKey, el.dataset.variantId);
    });
  });

  // Tooltip funcionalidad móvil con longpress
  document.querySelectorAll('.zoom-glow').forEach(el => {
    let longPressTimer;

    const showTooltip = () => el.classList.add('hover-touch');
    const hideTooltip = () => {
      clearTimeout(longPressTimer);
      el.classList.remove('hover-touch');
    };

    el.addEventListener('touchstart', () => {
      longPressTimer = setTimeout(showTooltip, 500); // 500ms long press
    });

    el.addEventListener('touchend', hideTooltip);
    el.addEventListener('touchcancel', hideTooltip);
  });
});